"use strict";
/*
 * Created on 17. 7. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var OptimizationGraph_1 = require("../model/OptimizationGraph");

var OptimizationGraphConverter_1 = require("./OptimizationGraphConverter");

var OptimizationGraphDataConverter_1 = require("./OptimizationGraphDataConverter");
/**
 * Implementation of {@link OptimizationGraphConverter}.
 * @author Radek Beran
 */


var OptimizationGraphConverterImpl =
/*#__PURE__*/
function (_OptimizationGraphCon) {
  _inherits(OptimizationGraphConverterImpl, _OptimizationGraphCon);

  function OptimizationGraphConverterImpl(optimizationGraphDataConverter) {
    var _this;

    _classCallCheck(this, OptimizationGraphConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptimizationGraphConverterImpl).call(this));
    _this.optimizationGraphDataConverter = optimizationGraphDataConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(OptimizationGraphConverterImpl, [{
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      result = Object.assign(result, {
        message: source.message,
        optimizationId: source.optimizationId
      });
      result = Object.assign(result, {
        result: conversions.asObjectOpt(source, 'result', function (object) {
          return _this2.optimizationGraphDataConverter.toDocument(object, conversions);
        })
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new OptimizationGraph_1.OptimizationGraph(OptimizationGraph_1.OptimizationGraph.schema.message.valueOfField(source), OptimizationGraph_1.OptimizationGraph.schema.optimizationId.valueOfField(source), OptimizationGraph_1.OptimizationGraph.schema.result.valueOfField(source));
    }
  }]);

  return OptimizationGraphConverterImpl;
}(OptimizationGraphConverter_1.OptimizationGraphConverter);

OptimizationGraphConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [OptimizationGraphDataConverter_1.OptimizationGraphDataConverter])], OptimizationGraphConverterImpl);
exports.OptimizationGraphConverterImpl = OptimizationGraphConverterImpl;